import React, { useEffect } from 'react';
import styled from 'styled-components';
import { objectBrowserStoreSelector, useObjectBrowserStore } from '@warehouse/object-browser/domain';
import { brokerJobsStoreSelector, JobsPanel, useBrokerJobsStore } from '@warehouse/object-browser/feature-broker';
import { ErrorAlert } from '@warehouse/shared/ui';
import NxLoader from '../../../../src/components/library/NxLoader';

export function LogsTab() {
	const selectedNxObject = useObjectBrowserStore(objectBrowserStoreSelector.selectedNxObject);
	const nxObjectUuid = selectedNxObject?.uuid ?? '';

	const isLoading = useBrokerJobsStore(brokerJobsStoreSelector.isLoading(nxObjectUuid));
	const isFetchError = useBrokerJobsStore(brokerJobsStoreSelector.isFetchError(nxObjectUuid));
	const { subscribe, unsubscribe } = useBrokerJobsStore(brokerJobsStoreSelector.internalActions);

	useEffect(() => {
		if (!nxObjectUuid) return undefined;
		subscribe(nxObjectUuid);
		return () => unsubscribe(nxObjectUuid);
	}, [nxObjectUuid, subscribe, unsubscribe]);

	if (!selectedNxObject) {
		return (
			<Wrapper>
				<NxLoader size={60} />
			</Wrapper>
		);
	}

	return (
		<Wrapper>
			{isFetchError && <ErrorAlert errorMessage="Failed to load jobs for this object" />}

			{!isFetchError && isLoading && (
				<LoaderWrapper>
					<NxLoader size={48} />
				</LoaderWrapper>
			)}

			{!isFetchError && !isLoading && <JobsPanel nxObjectUuid={nxObjectUuid} itemType={selectedNxObject.itemType} />}
		</Wrapper>
	);
}

const Wrapper = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	overflowY: 'auto',
	height: 'calc(100vh - 128px)',
	padding: theme.spacing(3, 3),
	boxSizing: 'border-box',

	'& body': {
		overflow: 'hidden !important',
	},
}));

const LoaderWrapper = styled('div')({
	alignItems: 'center',
	display: 'flex',
	flex: 1,
	justifyContent: 'center',
});
